import {SvgFactory, SvgFactoryConfig} from './lib/svg-factory';
let config = new SvgFactoryConfig();
config.iconName = "share-linkedin";
config.viewBox="0 0 31 31";
config.shape = `
    <g fill="var(--fill)" fill-rule="evenodd">
        <path fill="var(--fill-path1)" d="M15.777.29c-8.284 0-15 6.717-15 15 0 8.284 6.716 15 15 15 8.284 0 15-6.716 15-15 0-8.283-6.716-15-15-15z"/>
        <path fill="var(--fill-path2)" d="M24.218 22.662H20.47v-5.317c0-1.376-.57-2.328-1.873-2.328-.977 0-1.52.635-1.765 1.27-.108.211-.08.529-.08.82v5.555h-3.72s.053-9.392 0-10.238h3.72v1.588c.216-.689 1.384-1.694 3.284-1.694 2.334 0 4.18 1.481 4.18 4.656v5.688zM9.286 11.128H9.26c-1.195 0-1.982-.767-1.982-1.773 0-1.005.815-1.772 2.036-1.772 1.194 0 1.955.767 1.982 1.772 0 1.006-.788 1.773-2.009 1.773zm-1.575 1.296h3.312v10.238H7.711V12.424z"/>
    </g>
`;
let ShareLinkedInSVG = new SvgFactory(config);

export default ShareLinkedInSVG;